import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-capacitor',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Capacitor icon</title><path d="M24 3.7l-5.766 5.766 5.725 5.736-3.713 3.712L5.073 3.742 8.786.03l5.736 5.726L20.284 0 24 3.7zM.029 8.785l3.713-3.713 15.173 15.173-3.713 3.714-5.732-5.726L3.7 24 0 20.285l5.754-5.764L.029 8.785z"/></svg>`,
    styles: []
})
export class SimpleIconsCapacitorComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#119EFF';
    @Input() className: string = 'simple-icons-capacitor'
    constructor() {}
    ngOnInit(): void {}
}
